import type { GameSaveCampaign } from './IGameSaveManager';

/** Host policy may select a player slot or shared baseline; callers cannot supply a slot. */
export interface IGameSaveSlotSelector {
  selectGameSaveSlot(campaign: GameSaveCampaign): Promise<string>;
}

/** Production reset policy. Capturing this slot explicitly publishes a prepared baseline. */
export class HostBaselineGameSaveSlotSelector implements IGameSaveSlotSelector {
  async selectGameSaveSlot(_campaign: GameSaveCampaign): Promise<string> {
    return 'host-baseline';
  }
}
